function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2018, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import autoBind from 'react-autobind';
import { ChevronDown } from '@carbon/react/icons';
import client from '../../lib/shared/client';
import config from '../../lib/shared/config';
import hrefs from '../../lib/shared/hrefs';
import constants from '../../lib/shared/constants';
import { Information } from '@carbon/react/icons';
import { InlineLoading, SelectSkeleton, Tooltip } from '@carbon/react';
import messages from '../../nls/setup/deploy/deploy.properties';
import NameValidationJob from '../../lib/client/setup/deploy/toolchain-name-validation';
import Notification from '../common/notification.jsx';
import Phase from '../common/model/phase';
import Promise from 'bluebird';
import React from 'react';
import URITemplate from '../../lib/shared/uritemplate';
import xhrPromise from '../../lib/client/xhr-promise';
import PropTypes from 'prop-types';
import xhr from '../../lib/client/xhr';
import '../../scss/setup/deploy/_toolchain-name.scss';
var resourceGroupTemplate = new URITemplate("{+context}/setup/api/v2/resource_groups?account_context={account_context}&bss_account={bss_account}");
var toolchainsTemplate = new URITemplate("{+context}/setup/api/v2/toolchains?resource_group_id={rgid}");
var toolchainTemplate = new URITemplate("{+context}/toolchains/{tid}?includeSecretRefs=true");
// these are expanded below into the localized strings, e.g: provider.githubconsolidated
var validSourceProviders = constants.gitSourceProviders;
var validPipelineTypes = ['classic', 'tekton'];
var ToolchainNameSection = /*#__PURE__*/function (_React$Component) {
  function ToolchainNameSection(props) {
    var _this;
    _classCallCheck(this, ToolchainNameSection);
    _this = _callSuper(this, ToolchainNameSection, [props]);
    _this.state = {
      problem: "checking",
      errorMessage: "",
      fetchRG: false,
      initialValueChecked: false,
      pipelineType: "",
      resourceGroups: [],
      sourceProvider: "",
      toolchains: [],
      fetchingToolchains: false
    };
    // note this.props has: resourceGroup

    _this.nameValidationJob = new NameValidationJob();
    autoBind(_this);
    return _this;
  }
  _inherits(ToolchainNameSection, _React$Component);
  return _createClass(ToolchainNameSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Wizard flow requires to set source provider & pipeline type here
      this.setSourceProvider();
      this.setPipelineType();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nameValidationJob.cancel();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (prevProps.showDynamicPicker !== this.props.showDynamicPicker && this.props.showDynamicPicker) {
        // Classic flow requires to set source provider here
        this.setSourceProvider();
      }
      if (prevProps.showPipelineType !== this.props.showPipelineType && this.props.showPipelineType) {
        // Classic flow requires to set pipeline type here
        this.setPipelineType();
      }
      if (prevProps.resourceGroup.id !== this.props.resourceGroup.id) {
        // Check if the user access to the toolchain.
        this.checkForToolchainPermission(this.props.resourceGroup && this.props.resourceGroup.id || null);
      }
      if (this.props.value && !this.state.initialValueChecked) {
        if (!this.props.value.endsWith('{{timestamp}}')) {
          // only do this if timestamp has been expanded
          this.setState({
            initialValueChecked: true
          }, function () {
            _this2.validateName(_this2.props.value, _this2.props.resourceGroup, true);
          });
        }
      }
      var inputElement = this.refs.input;
      var account = this.props.account;
      if (!this.state.focused && inputElement) {
        if (this.state.problem === "empty" || this.state.problem === "error") {
          inputElement.setCustomValidity("invalid");
          inputElement.focus();
        } else {
          inputElement.setCustomValidity("");
        }
      }
      if (account && account !== this._account) {
        this._account = account;
        this.onAccountChange(this._account);
      }
      this._account = account;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        // Name was changed out from underneath us, must validate again
        this.validateName(nextProps.value, nextProps.resourceGroup, true);
      }
    }
  }, {
    key: "setSourceProvider",
    value: function setSourceProvider() {
      // Set the source provider
      var shouldShowProviderPicker = typeof window !== "undefined" && window.URLSearchParams && this.props.showDynamicPicker;
      if (shouldShowProviderPicker) {
        var urlSourceProvider = this.getPathParam("source_provider");
        var srcProvider;
        if (urlSourceProvider && validSourceProviders.includes(urlSourceProvider)) {
          srcProvider = urlSourceProvider;
        } else {
          var firstSourceService = this.props.capabilitiesList.find(function (serviceId) {
            return validSourceProviders.includes(serviceId);
          });
          if (firstSourceService) {
            srcProvider = firstSourceService;
          } else {
            srcProvider = validSourceProviders[0];
          }
        }
        this.setState({
          sourceProvider: srcProvider
        });
      }
    }
  }, {
    key: "setPipelineType",
    value: function setPipelineType() {
      // Set the pipeline type
      var shouldShowPipelineTypeSelector = this.props.showPipelineType;
      if (shouldShowPipelineTypeSelector) {
        // Set pipeline type from URL param, default to classic
        var type = this.getPathParam("pipeline_type") || "classic";
        this.setState({
          pipelineType: type
        });
      }
    }
  }, {
    key: "validateName",
    value: function validateName(value, resourceGroup, enable) {
      var _this3 = this;
      // must not contain ascii special chars except [ ._-]
      var match = /^[^\x00-\x1F\x7F`~!@#$%\^&*()+=[\]{}\\|;:'",<>\/?]+$/;
      var result = match.test(value);
      var resourceGroupId = resourceGroup && resourceGroup.id || null;
      if (result || value === "") {
        if (resourceGroupId === null) {
          this.setState({
            problem: ""
          });
          this.props.setNameValidity(true);
          if (this.context.wizardMode) {
            this.props.handleWizardWelcomeValid(enable);
          } else {
            this.props.isDeployButtonEnabled(enable);
          }
        } else if (value === "") {
          this.setState({
            problem: "empty"
          });
          this.props.setNameValidity(false);
          if (this.context.wizardMode) {
            this.props.handleWizardWelcomeValid(false);
          } else {
            this.props.isDeployButtonEnabled(enable);
          }
        } else {
          this.setState({
            problem: "checking"
          });
          this.props.setNameValidity(false);
          if (this.context.wizardMode) {
            this.props.handleWizardWelcomeValid(false);
          } else {
            this.props.isDeployButtonEnabled(false);
          }
          this.nameValidationJob.start(value, resourceGroupId, function (exists) {
            if (_this3.props.value !== value) {
              return;
            }
            if (exists.status === "error") {
              _this3.setState({
                problem: "error",
                errorMessage: exists.description || "",
                focused: true
              });
              _this3.props.setNameValidity(false);
              if (_this3.context.wizardMode) {
                _this3.props.handleWizardWelcomeValid(enable);
              } else {
                _this3.props.isDeployButtonEnabled(enable);
              }
            } else {
              _this3.setState({
                problem: "",
                focused: true
              });
              _this3.props.setNameValidity(true);
              if (_this3.context.wizardMode) {
                _this3.props.handleWizardWelcomeValid(enable);
              } else {
                _this3.props.isDeployButtonEnabled(enable);
              }
            }
          });
        }
      } else {
        this.setState({
          problem: "invalidChar"
        });
        this.props.setNameValidity(false);
        if (this.context.wizardMode) {
          this.props.handleWizardWelcomeValid(enable);
        } else {
          this.props.isDeployButtonEnabled(enable);
        }
      }
    }
  }, {
    key: "handleNameChange",
    value: function handleNameChange(event) {
      this.props.setDirtyFlag();
      var value = event.target.value;
      this.props.onNameChange(value);
      this.validateName(value, this.props.resourceGroup, true);
    }
  }, {
    key: "checkForToolchainPermission",
    value: function checkForToolchainPermission(rgId) {
      var _this4 = this;
      if (rgId) {
        var accountId = this.props.account && this.props.account.accountGuid;
        var url = hrefs.createPermissions(accountId, rgId, this.context.envId);
        this.setState({
          rgCreatePermission: 'loading'
        });
        xhr(url, {
          dataType: 'json'
        }, function (error, data, xhr) {
          if (error) {
            _this4.props.canCreateToolchain(false);
            // xhr.status can be either 403 or 500.
            _this4.setState({
              rgCreatePermission: 'error',
              rgCreatePermissionErrorType: xhr.status
            });
          }
          if (data !== null && data !== void 0 && data.allowed) {
            _this4.props.canCreateToolchain(true);
            _this4.setState({
              rgCreatePermission: 'allowed'
            });
          } else {
            _this4.props.canCreateToolchain(false);
            _this4.setState({
              rgCreatePermission: 'error',
              rgCreatePermissionErrorType: 403
            });
          }
        });
      }
    }
  }, {
    key: "handleFocusOut",
    value: function handleFocusOut(event) {
      var value = event.target.value;
      //check for leading and trailing spaces in toolchain name
      if (value !== '' && /^\s|\s$/.test(value)) {
        var newVal = value.trim();
        this.refs.input.value = newVal;
        this.props.onNameChange(newVal);
        this.validateName(newVal, this.props.resourceGroup, true);
      }
    }
  }, {
    key: "handleRegionChange",
    value: function handleRegionChange(event) {
      this.props.setDirtyFlag();
      var selectedRegion = this.props.tcRegions.filter(function (reg) {
        return reg.id === event.target.value;
      })[0];
      this.props.handleRegionChange(selectedRegion);
    }
  }, {
    key: "onAccountChange",
    value: function onAccountChange(account) {
      var _this5 = this;
      this.props.setDirtyFlag();
      this.setState({
        fetchRG: true
      });
      this.getRGSelect(account);
      this.props.handleClearRG(function () {
        _this5.setState({
          resourceGroups: []
        });
      });
    }
  }, {
    key: "handleRGChange",
    value: function handleRGChange(event) {
      var _this6 = this;
      this.props.setDirtyFlag();
      var selectedRG = this.state.resourceGroups.filter(function (rg) {
        return rg.id === event.target.value;
      })[0];
      if (selectedRG) {
        this.props.handleRGChange(selectedRG, function () {
          _this6.validateName(_this6.props.value, _this6.props.resourceGroup, true);
          _this6.getToolchainSelect(selectedRG.id);
        });
      }
    }
  }, {
    key: "handleToolchainSelectorChange",
    value: function handleToolchainSelectorChange(event) {
      if (this.props.linkToolchainOptions) {
        var selectedToolchain = this.state.toolchains.filter(function (tc) {
          return tc.toolchain_guid === event.target.value;
        })[0];
        if (selectedToolchain) {
          this.getToolchain(selectedToolchain.toolchain_guid);
        }
      }
    }
  }, {
    key: "getRGSelect",
    value: function getRGSelect(account) {
      var _this7 = this;
      if (client) {
        Promise.try(function () {
          if (account) {
            var promisesArray = [];
            if (_this7.props.context.enableRg) {
              var rgUrl = resourceGroupTemplate.expand({
                context: config.CONTEXT_PATH,
                bss_account: account.accountGuid,
                account_context: account.contextId
              });
              promisesArray.push(xhrPromise(rgUrl, {
                dataType: "json"
              }));
            }
            return Promise.all(promisesArray).then(function (resultsArray) {
              var resourceGroups = [],
                resourceGroup = {},
                enable = false;
              if (resultsArray.length > 0 && resultsArray[0].body.resources.length > 0) {
                resourceGroups = resultsArray[0].body.resources.sort(function (a, b) {
                  return a.name.toLocaleLowerCase().localeCompare(b.name.toLowerCase());
                });
                var defaultResourceGroup = resourceGroups.find(function (rg) {
                  return rg.id === window.localStorage['otc-ui.selected_rg'];
                });
                resourceGroup = defaultResourceGroup || resourceGroups[0] || {};
                enable = true;
              }
              _this7.setState({
                resourceGroups: resourceGroups
              }, function () {
                _this7.props.handleRGChange(resourceGroup, function () {
                  _this7.setState({
                    fetchRG: false
                  }, function () {
                    _this7.validateName(_this7.props.value, _this7.props.resourceGroup, enable);
                    _this7.getToolchainSelect(resourceGroup.id);
                  });
                });
              });
            });
          }
        }).catch(function (error) {
          _this7.setState({
            loadError: error
          });
        });
      }
    }
  }, {
    key: "getToolchainSelect",
    value: function getToolchainSelect(rgid) {
      var _this8 = this;
      if (client && this.props.linkToolchainOptions) {
        this.setState({
          fetchingToolchains: true
        });
        Promise.try(function () {
          var promisesArray = [];
          var tcUrl = toolchainsTemplate.expand({
            context: config.CONTEXT_PATH,
            rgid: rgid
          });
          promisesArray.push(xhrPromise(tcUrl, {
            dataType: "json"
          }));
          return Promise.all(promisesArray).then(function (resultsArray) {
            var _resultsArray$;
            _this8.setState({
              toolchains: ((_resultsArray$ = resultsArray[0]) === null || _resultsArray$ === void 0 || (_resultsArray$ = _resultsArray$.body) === null || _resultsArray$ === void 0 ? void 0 : _resultsArray$.items) || [],
              fetchingToolchains: false
            });
          });
        }).catch(function (error) {
          _this8.setState({
            loadError: error,
            toolchains: [],
            fetchingToolchains: false
          });
        });
      }
    }
  }, {
    key: "getToolchain",
    value: function getToolchain(tid) {
      var _this9 = this;
      if (client && this.props.linkToolchainOptions) {
        this.setState({
          fetchingToolchains: true
        });
        Promise.try(function () {
          var promisesArray = [];
          var tcUrl = toolchainTemplate.expand({
            context: config.CONTEXT_PATH,
            tid: tid
          });
          promisesArray.push(xhrPromise(tcUrl, {
            dataType: "json"
          }));
          return Promise.all(promisesArray).then(function (resultsArray) {
            var _resultsArray$2;
            _this9.setState({
              fetchingToolchains: false
            });
            if ((_resultsArray$2 = resultsArray[0]) !== null && _resultsArray$2 !== void 0 && _resultsArray$2.body && _this9.props.handleLinkToolchainLoaded) {
              var _resultsArray$3;
              var toolchain = resultsArray[0].body;
              if (toolchain.container) {
                toolchain.container.name = _this9.props.resourceGroup.name;
              }
              _this9.props.handleLinkToolchainLoaded((_resultsArray$3 = resultsArray[0]) === null || _resultsArray$3 === void 0 ? void 0 : _resultsArray$3.body);
            }
          });
        }).catch(function (error) {
          _this9.setState({
            loadError: error,
            fetchingToolchains: false
          });
        });
      }
    }
  }, {
    key: "getPathParam",
    value: function getPathParam(param) {
      var query = new URLSearchParams(window.location.search);
      return query.get(param);
    }
  }, {
    key: "renderToolchainName",
    value: function renderToolchainName(tcNameProps) {
      var _this10 = this;
      var defaultRegionValue = tcNameProps.defaultRegionValue,
        defaultRGValue = tcNameProps.defaultRGValue,
        extraRegionSelectorProps = tcNameProps.extraRegionSelectorProps,
        extraRGProps = tcNameProps.extraRGProps,
        extraTextboxProps = tcNameProps.extraTextboxProps,
        fetchRGSpinnerClass = tcNameProps.fetchRGSpinnerClass,
        phase = tcNameProps.phase,
        resourceGroupCount = tcNameProps.resourceGroupCount,
        rgTooltipText = tcNameProps.rgTooltipText,
        shouldShowProviderPicker = tcNameProps.shouldShowProviderPicker,
        shouldShowPipelineTypeSelector = tcNameProps.shouldShowPipelineTypeSelector,
        textSpinnerClass = tcNameProps.textSpinnerClass,
        tooltipText = tcNameProps.tooltipText,
        showToolchainPermissionError = tcNameProps.showToolchainPermissionError;
      return /*#__PURE__*/React.createElement("div", {
        className: "toolchain-name"
      }, /*#__PURE__*/React.createElement("div", {
        className: "v6header"
      }, phase !== Phase.LOADING && showToolchainPermissionError === "error" && /*#__PURE__*/React.createElement("div", {
        className: "textInfo"
      }, /*#__PURE__*/React.createElement(Notification, {
        kind: "warning",
        title: messages.get("toolchain.creation.access.title"),
        format: "markdown",
        subtitle: messages.get("toolchain.creation.access.msg") || ""
      })), /*#__PURE__*/React.createElement("div", {
        className: "toolchain-name-div"
      }, phase === Phase.LOADING ? /*#__PURE__*/React.createElement(SelectSkeleton, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "text-input",
        className: "cds--label toolchain-label"
      }, messages.get("label.tcName"), /*#__PURE__*/React.createElement(Tooltip, {
        label: messages.get("label.tcName.tooltip"),
        enterDelayMs: 0,
        leaveDelayMs: 0,
        align: "right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sb-tooltip-trigger"
      }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement("input", _extends({
        ref: "input",
        id: "text-input",
        maxLength: constants.maxToolchainNameLength,
        onChange: this.handleNameChange,
        value: this.props.value,
        onBlur: this.handleFocusOut,
        className: "cds--text-input",
        required: "",
        type: "text"
      }, extraTextboxProps)), /*#__PURE__*/React.createElement("div", {
        className: "cds--form-requirement"
      }, tooltipText), /*#__PURE__*/React.createElement("div", {
        className: textSpinnerClass
      }, /*#__PURE__*/React.createElement(InlineLoading, {
        className: "spinner-icon"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "region-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rg-selector-div cds--form-item"
      }, phase === Phase.LOADING || !this.props.tcRegions ? /*#__PURE__*/React.createElement("div", {
        className: "skeleton-container"
      }, /*#__PURE__*/React.createElement(SelectSkeleton, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "cds--select"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "region-select",
        className: "cds--label rg-label"
      }, messages.get("label.selectLocation"), /*#__PURE__*/React.createElement(Tooltip, {
        label: messages.get("label.selectLocation.tooltip"),
        enterDelayMs: 0,
        leaveDelayMs: 0,
        align: "right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sb-tooltip-trigger"
      }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", _extends({
        ref: "regionSelector",
        id: "region-select",
        className: "cds--select-input",
        onChange: this.handleRegionChange,
        defaultValue: defaultRegionValue
      }, extraRegionSelectorProps), this.props.tcRegions.map(function (option) {
        var name = option.display_name;
        var id = option.id;
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: id,
          value: id
        }, name);
      })), /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "optional-link"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "empty-div"
      }), /*#__PURE__*/React.createElement("div", {
        className: "rg-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rg-selector-div cds--form-item"
      }, phase === Phase.LOADING ? /*#__PURE__*/React.createElement("div", {
        className: "skeleton-container"
      }, /*#__PURE__*/React.createElement(SelectSkeleton, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "cds--select"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "resource-group-select",
        className: "cds--label rg-label"
      }, messages.get("label.selectRG"), /*#__PURE__*/React.createElement(Tooltip, {
        label: messages.get("label.selectRG.tooltip"),
        enterDelayMs: 0,
        leaveDelayMs: 0,
        align: "right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sb-tooltip-trigger"
      }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", _extends({
        ref: "resourceGroupSelector",
        id: "resource-group-select",
        className: "cds--select-input",
        defaultValue: defaultRGValue,
        onChange: this.handleRGChange
      }, extraRGProps), resourceGroupCount === 0 ? /*#__PURE__*/React.createElement("option", {
        className: "cds--select-option",
        value: rgTooltipText
      }, rgTooltipText) : this.state.resourceGroups.map(function (option) {
        var name = option.name;
        var id = option.id;
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: id,
          value: id
        }, name);
      })), /*#__PURE__*/React.createElement("div", {
        className: fetchRGSpinnerClass
      }, /*#__PURE__*/React.createElement(InlineLoading, {
        className: "spinner-icon"
      })), resourceGroupCount !== 0 ? /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }) : null)), /*#__PURE__*/React.createElement("div", {
        className: "optional-link"
      }))))), (shouldShowProviderPicker || shouldShowPipelineTypeSelector) && /*#__PURE__*/React.createElement("div", {
        className: "flex-row"
      }, shouldShowProviderPicker && !!this.state.sourceProvider && /*#__PURE__*/React.createElement("div", {
        className: "provider-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "provider-selector-div cds--form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--select"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "provider-select",
        className: "cds--label provider-label"
      }, messages.get("label.selectSourceProvider"), /*#__PURE__*/React.createElement(Tooltip, {
        label: messages.get("label.selectSourceProvider.tooltip"),
        enterDelayMs: 0,
        leaveDelayMs: 0,
        align: "right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sb-tooltip-trigger"
      }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", {
        id: "provider-select",
        className: "cds--select-input",
        onChange: function onChange(event) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set("source_provider", event.target.value);
          if (history.pushState) {
            var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(searchParams.toString());
            window.history.pushState({
              path: newurl
            }, "", newurl);

            // Reset initialValueChecked here as we need the toolchain name validity to
            // be re-checked after the template is reloaded
            _this10.setState({
              initialValueChecked: false,
              sourceProvider: event.target.value
            });
            _this10.props.reloadTemplate({
              sourceProvider: event.target.value
            });
          }
        },
        defaultValue: this.state.sourceProvider
      }, validSourceProviders.map(function (provider) {
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: provider,
          value: provider
        }, messages.get("provider.".concat(provider)));
      })), /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "empty-div"
      }), shouldShowPipelineTypeSelector && !!this.state.pipelineType && /*#__PURE__*/React.createElement("div", {
        className: "provider-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "provider-selector-div cds--form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--select"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "pipeline-type-select",
        className: "cds--label provider-label"
      }, messages.get("label.selectPipeline"), /*#__PURE__*/React.createElement(Tooltip, {
        label: messages.get("label.selectPipeline.tooltip"),
        enterDelayMs: 0,
        leaveDelayMs: 0,
        align: "right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sb-tooltip-trigger"
      }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", {
        id: "pipeline-type-select",
        className: "cds--select-input",
        onChange: function onChange(event) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set("pipeline_type", event.target.value);
          if (history.pushState) {
            var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(searchParams.toString());
            window.history.pushState({
              path: newurl
            }, "", newurl);

            // Reset initialValueChecked here as we need the toolchain name validity to
            // be re-checked after the template is reloaded
            _this10.setState({
              initialValueChecked: false,
              pipelineType: event.target.value
            });
            _this10.props.reloadTemplate({
              pipelineType: event.target.value
            });
          }
        },
        defaultValue: this.state.pipelineType
      }, validPipelineTypes.map(function (t) {
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: t,
          value: t
        }, messages.get("pipelinetype.".concat(t)));
      })), /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }))))))));
    }
  }, {
    key: "renderWizardName",
    value: function renderWizardName(tcNameProps) {
      var _this11 = this;
      var allowedRegion = tcNameProps.allowedRegion,
        defaultRegionValue = tcNameProps.defaultRegionValue,
        defaultRGValue = tcNameProps.defaultRGValue,
        extraRegionSelectorProps = tcNameProps.extraRegionSelectorProps,
        extraRGProps = tcNameProps.extraRGProps,
        extraTextboxProps = tcNameProps.extraTextboxProps,
        fetchRGSpinnerClass = tcNameProps.fetchRGSpinnerClass,
        phase = tcNameProps.phase,
        resourceGroupCount = tcNameProps.resourceGroupCount,
        rgTooltipText = tcNameProps.rgTooltipText,
        shouldShowProviderPicker = tcNameProps.shouldShowProviderPicker,
        shouldShowPipelineTypeSelector = tcNameProps.shouldShowPipelineTypeSelector,
        textSpinnerClass = tcNameProps.textSpinnerClass,
        tooltipText = tcNameProps.tooltipText,
        linkToolchainOptions = tcNameProps.linkToolchainOptions,
        showToolchainPermissionError = tcNameProps.showToolchainPermissionError;
      var showRegionPermissionNotification = !allowedRegion;
      // Note, this subtitle does not have a link; would be ok to use <InlineNotification
      // without error blank page, but using <Notification for consistency.
      var regionPermissionNotification = showRegionPermissionNotification && /*#__PURE__*/React.createElement("div", {
        className: "textInfo"
      }, /*#__PURE__*/React.createElement(Notification, {
        kind: "error",
        title: messages.get("error.allowedRegionTitle"),
        subtitle: messages.get("error.allowedRegionMsg")
      }));
      var showCreationPermissionNotification = phase !== Phase.LOADING && showToolchainPermissionError === "error";
      var creationPermissionNotification = showCreationPermissionNotification && /*#__PURE__*/React.createElement("div", {
        className: "textInfo"
      }, /*#__PURE__*/React.createElement(Notification, {
        kind: "warning",
        title: messages.get("toolchain.creation.access.title"),
        format: "markdown",
        subtitle: messages.get("toolchain.creation.access.msg") || ""
      }));
      var requiredFields = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "toolchain-name-div"
      }, phase === Phase.LOADING ? /*#__PURE__*/React.createElement(SelectSkeleton, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "text-input",
        className: "cds--label toolchain-label"
      }, messages.get("label.tcName"), /*#__PURE__*/React.createElement(Tooltip, {
        label: messages.get("label.tcName.tooltip"),
        enterDelayMs: 0,
        leaveDelayMs: 0,
        align: "right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sb-tooltip-trigger"
      }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement("input", _extends({
        ref: "input",
        id: "text-input",
        maxLength: constants.maxToolchainNameLength,
        onChange: this.handleNameChange,
        value: this.props.value,
        onBlur: this.handleFocusOut,
        className: "cds--text-input cds--text-input--light",
        required: "",
        type: "text"
      }, extraTextboxProps)), /*#__PURE__*/React.createElement("div", {
        className: "cds--form-requirement"
      }, tooltipText), /*#__PURE__*/React.createElement("div", {
        className: textSpinnerClass
      }, /*#__PURE__*/React.createElement(InlineLoading, {
        className: "spinner-icon"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "region-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rg-selector-div cds--form-item"
      }, phase === Phase.LOADING || !this.props.tcRegions ? /*#__PURE__*/React.createElement("div", {
        className: "skeleton-container"
      }, /*#__PURE__*/React.createElement(SelectSkeleton, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "cds--select cds--select--light"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "region-select",
        className: "cds--label rg-label"
      }, messages.get("label.selectLocation"), /*#__PURE__*/React.createElement(Tooltip, {
        label: messages.get("label.selectLocation.tooltip"),
        enterDelayMs: 0,
        leaveDelayMs: 0,
        align: "right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sb-tooltip-trigger"
      }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", _extends({
        ref: "regionSelector",
        id: "region-select",
        className: "cds--select-input ",
        onChange: this.handleRegionChange,
        defaultValue: defaultRegionValue
      }, extraRegionSelectorProps), this.props.tcRegions.map(function (option) {
        var name = option.display_name;
        var id = option.id;
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: id,
          value: id
        }, name);
      })), /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "optional-link"
      }))))));
      var rgSelector = /*#__PURE__*/React.createElement("div", {
        className: "flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rg-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rg-selector-div cds--form-item"
      }, phase === Phase.LOADING ? /*#__PURE__*/React.createElement("div", {
        className: "skeleton-container"
      }, /*#__PURE__*/React.createElement(SelectSkeleton, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "cds--select cds--select--light"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "resource-group-select",
        className: "cds--label rg-label"
      }, messages.get("label.selectRG"), /*#__PURE__*/React.createElement(Tooltip, {
        label: messages.get("label.selectRG.tooltip"),
        enterDelayMs: 0,
        leaveDelayMs: 0,
        align: "right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "sb-tooltip-trigger"
      }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", _extends({
        ref: "resourceGroupSelector",
        id: "resource-group-select",
        className: "cds--select-input",
        defaultValue: defaultRGValue,
        onChange: this.handleRGChange
      }, extraRGProps), resourceGroupCount === 0 ? /*#__PURE__*/React.createElement("option", {
        className: "cds--select-option",
        value: rgTooltipText
      }, rgTooltipText) : this.state.resourceGroups.map(function (option) {
        var name = option.name;
        var id = option.id;
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: id,
          value: id
        }, name);
      })), /*#__PURE__*/React.createElement("div", {
        className: fetchRGSpinnerClass
      }, /*#__PURE__*/React.createElement(InlineLoading, {
        className: "spinner-icon"
      })), resourceGroupCount !== 0 ? /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }) : null)), /*#__PURE__*/React.createElement("div", {
        className: "optional-link"
      })))));

      // Only show resource group selector when more than 1 option available
      var isRGSelectorVisible = false;
      if (resourceGroupCount > 1) {
        isRGSelectorVisible = true;
      }
      var linkToolchainNotification = null;
      var linkToolchainSelector = null;
      if (linkToolchainOptions) {
        if (linkToolchainOptions !== null && linkToolchainOptions !== void 0 && linkToolchainOptions.notification) {
          var kind = linkToolchainOptions.notification.style || "info";
          var title = linkToolchainOptions.notification.title || "";
          var subtitle = linkToolchainOptions.notification.subtitle || "";
          // Note, this subtitle is configurable by the template author;
          // our DevSecOps CD notification doesn't contain any links,
          // but other user-authored notifications might
          // so, using <Notification instead of <InlineNotification
          // so as to prevent potential error on presence of link.
          linkToolchainNotification = /*#__PURE__*/React.createElement("div", {
            className: "textInfo"
          }, /*#__PURE__*/React.createElement(Notification, {
            kind: kind,
            lowContrast: true,
            title: title,
            format: "markdown",
            subtitle: subtitle || ""
          }));
        }
        var fetchToolchainsSpinnerClass;
        if (this.state.fetchingToolchains) {
          fetchToolchainsSpinnerClass = 'text-spinner dropdown-spinner';
        } else {
          fetchToolchainsSpinnerClass = 'text-spinner dropdown-spinner info-desc-hidden';
        }
        linkToolchainSelector = /*#__PURE__*/React.createElement("div", {
          className: "flex-row link-toolchain-row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "link-toolchain-div"
        }, /*#__PURE__*/React.createElement("div", {
          className: "rg-selector-div cds--form-item"
        }, phase === Phase.LOADING ? /*#__PURE__*/React.createElement("div", {
          className: "skeleton-container"
        }, /*#__PURE__*/React.createElement(SelectSkeleton, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "cds--select cds--select--light"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "link-tc-select",
          className: "cds--label rg-label"
        }, linkToolchainOptions === null || linkToolchainOptions === void 0 ? void 0 : linkToolchainOptions.label), /*#__PURE__*/React.createElement("div", {
          className: "cds--select-input__wrapper"
        }, /*#__PURE__*/React.createElement("select", {
          ref: "tcSelector",
          id: "link-tc-select",
          className: "cds--select-input",
          onChange: this.handleToolchainSelectorChange
        }, /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          value: -1
        }, messages.get("wizard.option.none")), this.state.toolchains.map(function (option) {
          var name = option.name;
          var id = option.toolchain_guid;
          return /*#__PURE__*/React.createElement("option", {
            className: "cds--select-option",
            key: id,
            value: id
          }, name);
        })), /*#__PURE__*/React.createElement("div", {
          className: fetchToolchainsSpinnerClass
        }, /*#__PURE__*/React.createElement(InlineLoading, {
          className: "spinner-icon"
        })), /*#__PURE__*/React.createElement(ChevronDown, {
          className: "cds--select__arrow"
        })))))));
      }
      var providerPicker = shouldShowProviderPicker && !!this.state.sourceProvider && /*#__PURE__*/React.createElement("div", {
        className: "flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "provider-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "provider-selector-div cds--form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--select cds--select--light"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "provider-select",
        className: "cds--label provider-label"
      }, messages.get("label.selectSourceProvider")), /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", {
        id: "provider-select",
        className: "cds--select-input",
        onChange: function onChange(event) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set("source_provider", event.target.value);
          if (history.pushState) {
            var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(searchParams.toString());
            window.history.pushState({
              path: newurl
            }, "", newurl);

            // Reset initialValueChecked here as we need the toolchain name validity to
            // be re-checked after the template is reloaded
            _this11.setState({
              initialValueChecked: false,
              sourceProvider: event.target.value
            });
            _this11.props.reloadTemplate({
              sourceProvider: event.target.value
            });
          }
        },
        defaultValue: this.state.sourceProvider
      }, validSourceProviders.map(function (provider) {
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: provider,
          value: provider
        }, messages.get("provider.".concat(provider)));
      })), /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }))))));
      var pipelineTypeSelector = shouldShowPipelineTypeSelector && !!this.state.pipelineType && /*#__PURE__*/React.createElement("div", {
        className: "provider-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "provider-selector-div cds--form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--select cds--select--light"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "pipeline-type-select",
        className: "cds--label provider-label"
      }, messages.get("label.selectPipeline")), /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", {
        id: "pipeline-type-select",
        className: "cds--select-input",
        onChange: function onChange(event) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set("pipeline_type", event.target.value);
          if (history.pushState) {
            var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(searchParams.toString());
            window.history.pushState({
              path: newurl
            }, "", newurl);

            // Reset initialValueChecked here as we need the toolchain name validity to
            // be re-checked after the template is reloaded
            _this11.setState({
              initialValueChecked: false,
              pipelineType: event.target.value
            });
            _this11.props.reloadTemplate({
              pipelineType: event.target.value
            });
          }
        },
        defaultValue: this.state.pipelineType
      }, validPipelineTypes.map(function (t) {
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: t,
          value: t
        }, messages.get("pipelinetype.".concat(t)));
      })), /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      })))));
      return /*#__PURE__*/React.createElement("div", {
        className: "toolchain-name"
      }, /*#__PURE__*/React.createElement("div", {
        className: "v6header"
      }, regionPermissionNotification, creationPermissionNotification, requiredFields, isRGSelectorVisible && rgSelector, providerPicker, pipelineTypeSelector, linkToolchainNotification, linkToolchainSelector));
    }
  }, {
    key: "render",
    value: function render() {
      var tooltipText,
        textSpinnerClass,
        fetchRGSpinnerClass,
        rgTooltipText = '',
        extraTextboxProps = {},
        extraRegionSelectorProps = {},
        defaultRegionValue,
        extraRGProps = {};
      var resourceGroupCount = this.state.resourceGroups.length;
      var defaultRGValue = this.props.resourceGroup && this.props.resourceGroup.id || null;
      var _this$props = this.props,
        allowedRegion = _this$props.allowedRegion,
        linkToolchainOptions = _this$props.linkToolchainOptions,
        phase = _this$props.phase;
      var shouldShowProviderPicker = typeof window !== 'undefined' && window.URLSearchParams && this.props.showDynamicPicker;
      var shouldShowPipelineTypeSelector = this.props.showPipelineType;
      var showToolchainPermissionError = this.state.rgCreatePermission;
      if (this.state.problem === "empty") {
        extraTextboxProps["data-invalid"] = true;
        tooltipText = messages.get("error.toolchainName");
        textSpinnerClass = 'text-spinner info-desc-hidden';
      } else if (this.state.problem === "invalidChar") {
        extraTextboxProps["data-invalid"] = true;
        tooltipText = messages.get("error.invalidChars");
        textSpinnerClass = 'text-spinner info-desc-hidden';
      } else if (this.state.problem === "error") {
        extraTextboxProps["data-invalid"] = true;
        tooltipText = this.state.errorMessage;
        textSpinnerClass = 'text-spinner info-desc-hidden';
      } else if (this.state.problem === "checking") {
        tooltipText = "";
        textSpinnerClass = 'text-spinner';
      } else {
        tooltipText = "";
        textSpinnerClass = 'text-spinner info-desc-hidden';
      }
      if (resourceGroupCount === 0) {
        if (this.state.fetchRG) {
          rgTooltipText = messages.get("loading");
        } else {
          rgTooltipText = messages.get("error.norgsInAccount");
        }
      }
      if (resourceGroupCount === 0) {
        extraRGProps["disabled"] = true;
        extraRGProps["data-invalid"] = true;
      }
      if (this.state.fetchRG) {
        fetchRGSpinnerClass = 'text-spinner dropdown-spinner';
      } else {
        fetchRGSpinnerClass = 'text-spinner dropdown-spinner info-desc-hidden';
      }
      var regionId = this.props.region ? this.props.region.id : null;
      defaultRegionValue = regionId;
      if (this.context.wizardMode) {
        return this.renderWizardName({
          allowedRegion: allowedRegion,
          defaultRegionValue: defaultRegionValue,
          defaultRGValue: defaultRGValue,
          extraRegionSelectorProps: extraRegionSelectorProps,
          extraRGProps: extraRGProps,
          extraTextboxProps: extraTextboxProps,
          fetchRGSpinnerClass: fetchRGSpinnerClass,
          phase: phase,
          resourceGroupCount: resourceGroupCount,
          rgTooltipText: rgTooltipText,
          shouldShowProviderPicker: shouldShowProviderPicker,
          shouldShowPipelineTypeSelector: shouldShowPipelineTypeSelector,
          textSpinnerClass: textSpinnerClass,
          tooltipText: tooltipText,
          linkToolchainOptions: linkToolchainOptions,
          showToolchainPermissionError: showToolchainPermissionError
        });
      }
      return this.renderToolchainName({
        defaultRegionValue: defaultRegionValue,
        defaultRGValue: defaultRGValue,
        extraRegionSelectorProps: extraRegionSelectorProps,
        extraRGProps: extraRGProps,
        extraTextboxProps: extraTextboxProps,
        fetchRGSpinnerClass: fetchRGSpinnerClass,
        phase: phase,
        resourceGroupCount: resourceGroupCount,
        rgTooltipText: rgTooltipText,
        shouldShowProviderPicker: shouldShowProviderPicker,
        shouldShowPipelineTypeSelector: shouldShowPipelineTypeSelector,
        textSpinnerClass: textSpinnerClass,
        tooltipText: tooltipText,
        showToolchainPermissionError: showToolchainPermissionError
      });
    }
  }]);
}(React.Component);
export { ToolchainNameSection as default };
ToolchainNameSection.contextTypes = {
  envId: PropTypes.string,
  wizardMode: PropTypes.bool
};